import { IntegrationContainerSkeleton } from "./IntegrationContainerSkeleton";
import styles from "./SiteIntegrations.module.scss";

export const SiteIntegrationsSkeleton = () => {
  return (
    <div className={styles.root}>
      <IntegrationContainerSkeleton />
      <IntegrationContainerSkeleton />
    </div>
  );
};
